import { Seo } from "@/components/Seo";

const RELEASES = [
  { date: "Spring 2026", title: "1123 Publishing announces TCPI Curriculum Volume I", body: "The institutional companion volume to The Crown Path Initiative is now available for adoption by schools, foundations, and community organizations." },
  { date: "Winter 2025", title: "CEO Almeer kilee Nance leads 1123 Publishing onto independent publishers' watch list", body: "1123 Publishing was recognized for the dual model of imprint + foundation that distinguishes the house in independent publishing." },
  { date: "Autumn 2025", title: "Feral acquired for limited-run hardcover printing", body: "1123's fourth hardcover title moves to international distribution." },
];

const INTERVIEWS = [];

export default function Media() {
  return (
    <div data-testid="media-page">
      <Seo
        title="Media Center | Press & Interviews | 1123 Publishing Company"
        description="Press releases, interviews, and media resources from 1123 Publishing Company — announcements on new titles, TCPI curriculum adoption, and CEO Almeer kilee Nance."
        path="/media"
      />
      <section className="bg-navy text-ivory py-20 md:py-28 relative overflow-hidden">
        <div className="parchment-overlay" />
        <div className="relative max-w-4xl mx-auto px-6 text-center">
          <div className="overline text-gold mb-4">Media Center</div>
          <h1 className="font-serif text-5xl md:text-6xl">Press, Interviews & Resources.</h1>
        </div>
      </section>

      <section className="py-20 md:py-28 bg-white">
        <div className="max-w-5xl mx-auto px-6 md:px-10">
          <div className="grid md:grid-cols-3 gap-12">
            <div className="md:col-span-2">
              <div className="overline mb-3">Press Releases</div>
              <h2 className="font-serif text-3xl text-navy mb-8">Recent Announcements</h2>
              <div className="space-y-8">
                {RELEASES.map((r) => (
                  <article key={r.title} className="border-l-2 border-gold pl-6">
                    <div className="overline">{r.date}</div>
                    <h3 className="font-serif text-xl text-navy mt-2">{r.title}</h3>
                    <p className="mt-2 text-charcoal/80 leading-relaxed text-sm">{r.body}</p>
                  </article>
                ))}
              </div>
            </div>

            <aside className="space-y-10">
              <div>
                <div className="overline mb-3">Interviews</div>
                {INTERVIEWS.length === 0 ? (
                  <div className="border border-dashed border-navy/20 p-5 text-sm text-charcoal/70 italic leading-relaxed">
                    Our interview archive is just getting started &mdash; check back soon.
                  </div>
                ) : (
                  <ul className="space-y-4">
                    {INTERVIEWS.map((i) => (
                      <li key={i.title} className="border-b border-navy/10 pb-3">
                        <div className="font-serif text-lg text-navy">
                          {i.url ? <a href={i.url} target="_blank" rel="noopener noreferrer" className="hover:text-gold">{i.title}</a> : i.title}
                        </div>
                        <div className="text-xs text-charcoal/60 mt-1 uppercase tracking-wider">{i.outlet} &middot; {i.date}</div>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
              <div className="bg-parchment border border-navy/15 p-6">
                <div className="overline mb-2">Brand Assets</div>
                <p className="text-sm text-charcoal/80 leading-relaxed">Logo files, CEO portraits, and style guidelines available on request.</p>
                <a href="mailto:1123publishing@gmail.com" className="block mt-3 text-navy underline underline-offset-4 text-sm">1123publishing@gmail.com</a>
              </div>
            </aside>
          </div>
        </div>
      </section>

      <section className="py-20 bg-parchment border-t border-navy/10">
        <div className="max-w-3xl mx-auto px-6">
          <div className="overline">CEO & Author Bio</div>
          <h2 className="font-serif text-4xl text-navy mt-3">Almeer kilee Nance</h2>
          <p className="mt-5 text-charcoal/85 leading-relaxed">
            CEO of 1123 Publishing Company and author of <em>Feral: Arise and Remember Who You Are</em>, <em>Poe Dad no Dad</em>, <em>Crown Ledger</em>,
            and <em>The Crown Path Initiative</em>, Almeer kilee Nance leads the imprint from a single conviction: that the
            stories a community tells about itself become the inheritance of its next generation. He is the architect of TCPI
            — a seven-track program for transformation now piloted in schools, foundations, and community organizations,
            and a leading voice for justice-impacted authors and youth mentorship programs based in Knoxville, Tennessee.
          </p>
        </div>
      </section>
    </div>
  );
}
